import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { formatDate, readingMinutes } from "@/lib/format";
import { categoryLabel } from "@/lib/categories";

export default function ArticleRow({ article, index = 0 }) {
  const { lang, tr } = useLang();
  const t = tr("common");
  const c = article[lang] || article.it || {};
  const href = `/${article.section === "knowledge" ? "knowledge-center" : "insights"}/${article.slug}`;
  const mins = readingMinutes(c.body);

  return (
    <Link
      to={href}
      data-testid={`article-row-${article.slug}`}
      className="group grid grid-cols-[auto_1fr] items-start gap-6 border-t border-gold/15 py-8 transition-colors last:border-b hover:bg-white/[0.02] md:grid-cols-[3.5rem_1fr_auto] md:items-center"
    >
      <span className="pt-1 font-mono text-sm text-gold/80 md:pt-0">{String(index + 1).padStart(2, "0")}</span>
      <div>
        <div className="flex flex-wrap items-center gap-3">
          <span className="border border-gold/30 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold-bright">
            {categoryLabel(article.category, lang)}
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-ivory/40">
            {formatDate(article.published_at, lang)} · {mins} {t.minRead}
          </span>
        </div>
        <h3 className="mt-4 font-serif text-xl leading-snug text-ivory transition-colors group-hover:text-gold-bright md:text-2xl">
          {c.title}
        </h3>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-ivory/55">{c.excerpt}</p>
      </div>
      <span className="hidden items-center gap-4 md:flex">
        {article.cover_url && (
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}${article.cover_url}`}
            alt=""
            className="h-14 w-24 border border-gold/25 object-cover"
            data-testid={`article-thumb-${article.slug}`}
          />
        )}
        <span className="flex h-11 w-11 items-center justify-center border border-gold/30 text-gold transition-all group-hover:bg-gold group-hover:text-navy">
          <ArrowRight className="h-4 w-4" />
        </span>
      </span>
    </Link>
  );
}
